import { render } from "./bonusWho.vue?vue&type=template&id=2cd786e3&scoped=true"
import script from "./bonusWho.vue?vue&type=script&lang=js"
export * from "./bonusWho.vue?vue&type=script&lang=js"

import "./bonusWho.vue?vue&type=style&index=0&id=2cd786e3&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd786e3"]])

export default __exports__